export { positionElements, Positioning } from './ng-positioning'
export { PositioningService, PositioningOptions } from './positioning.service';



// WEBPACK FOOTER //
// ./src/app/typescripts/free/utils/positioning/index.ts